/**
 * Time
 */
const time = {}
time.start = Date.now()
time.current = time.start
time.elapsed = 0
time.delta = 16

/**
 * Callbacks
 */
const callbacks = []

/**
 * Tick
 */
const tickCallback = () =>
{
    window.requestAnimationFrame(tickCallback)

    // Update time
    const current = Date.now()

    time.delta = current - time.current
    time.elapsed = current - time.start
    time.current = current

    if(time.delta > 60)
    {
        time.delta = 60
    }

    // Call callbacks
    for(const _callback of callbacks)
    {
        _callback()
    }
}

window.requestAnimationFrame(tickCallback)

/**
 * Mixin
 */
export default {
    created: function()
    {
        this.time = time

        // Save callbacks
        callbacks.push(this.onTick)
    },

    destroyed: function()
    {
        // Delete callbacks
        callbacks.splice(callbacks.findIndex((_item) => _item === this.onTick), 1)
    },

    methods:
    {
        onTick: function()
        {
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/Time.js